module.exports = __webpack_public_path__ + "img/LITHO_COVER.e4e4e9a5.jpg";